jQuery(function($){
  var $window = $(window);
  var $otonaContent = $(".otona-box");
  var $otonaBtnsPC = $(".otona-btns .otona--btn");
  var $otonaBtnsSP = $otonaContent.find(".otona--btn");
  var _isSP = false;

  var ContentAppearPC = function(event){
    var _$this = $(event.currentTarget);
    var _taregetotonaContent = "otona-box" + _$this.data("target");
    if(_$this.hasClass("otona--btn-current")){
      return;
    }
    $otonaContent.each(function(){
      var __$this = $(this);
      if(__$this.hasClass(_taregetotonaContent)){
        __$this.addClass("otona-box-open");
      }else{
        __$this.removeClass("otona-box-open");
      }
    });

    $otonaBtnsPC.each(function(i){
      var __$this = $(this);
      __$this.removeClass("otona--btn-current");
      if(i === (parseInt(_$this.data("target")) - 1)){
        __$this.addClass("otona--btn-current");
      }
    });
  };

  var ContentAppearSP = function(event){
    var _$this = $(event.currentTarget);
    var _$parent = _$this.parent();
    var _$contentWrap = _$parent.find(".otona-content-wrap");
    _$contentWrap.stop().slideToggle(function(){
      if(_$parent.hasClass("otona-box-open") && _$contentWrap.css("display") === "none"){
        _$parent.removeClass("otona-box-open")
      }else{
        _$parent.addClass("otona-box-open")
      }
    });
  };

  $otonaBtnsPC.each(function(){
    $(this).on("click", ContentAppearPC);
  });
  $otonaBtnsSP.each(function(){
    $(this).on("click", ContentAppearSP);
  });

  var CurrentSetPC = function(num){
    $otonaBtnsPC.each(function(i){
      var __$this = $(this);
      if(i === num){
        $($otonaContent[i]).addClass("otona-box-open");
        __$this.addClass("otona--btn-current");
      }else{
        $($otonaContent[i]).removeClass("otona-box-open");
        __$this.removeClass("otona--btn-current");
      }
    });
  };

  var Resizer = function(){
    if($window.width() > 750){
      if(_isSP){
        _isSP = false;
        var _$open = $(".otona-box-open");
        $otonaContent.each(function(){
          $(this).find(".otona-content-wrap").css({display: ""});
        });
        if(_$open.length === 0){
          CurrentSetPC(0);
        }else{
          var _taregetNum = parseInt($(_$open[0]).find(".otona--btn").data("target")) - 1;
          CurrentSetPC(_taregetNum);
        }
      }
    }else{
      if(!_isSP){
        _isSP = true;
        // SP
      }
    }
  };

  $window.on("resize", Resizer);
  Resizer();
});